export const environment = {
  id: '50',
  production: false,
  baseUrl: 'https://50.superlikerslabs.com',
  photosPath: 'https://super-likers.s3.amazonaws.com/uploads/upload-photo'
}
